import { $context } from '.';

export default function install(Vue) {
  zmSelectDropdownWidthLimit(Vue);
}

function zmSelectDropdownWidthLimit(Vue) {
  const STYLE_ELM_STORE_KEY = '__zmSelectDropdownWidthLimitStyleElm__';

  function getConfig({ disabled = $context.is.desktop, align = 'left', ...restConfig }) {
    return { ...restConfig, disabled, align };
  }

  function createOrUpdate(el, binding) {
    const { disabled, popperClass, widthReferenceElement, align } = getConfig(binding.value);
    if (disabled) return;

    if (popperClass) {
      let styleElm = el[STYLE_ELM_STORE_KEY];
      if (!(styleElm instanceof HTMLStyleElement)) {
        styleElm = el[STYLE_ELM_STORE_KEY] = document.createElement('style');
        document.head.appendChild(styleElm);
      }

      const widthReferenceElm = widthReferenceElement instanceof HTMLElement ? widthReferenceElement : el;
      const maxWidth = widthReferenceElm.getBoundingClientRect().width;
      const style = { 'max-width': `${maxWidth}px` };
      if (align === 'right') {
        style.right = `${window.innerWidth - el.getBoundingClientRect().right}px`;
        style.left = 'unset !important';
      }
      const styleContent = Object.keys(style).reduce((acc, key) => `${acc}${key}:${style[key]};`, '');
      styleElm.textContent = `.${popperClass}{${styleContent}}`;
    }
  }

  function unbind(el, bindingValue) {
    const { disabled } = getConfig(bindingValue);
    if (disabled) return;

    const styleElm = el[STYLE_ELM_STORE_KEY];
    if (styleElm instanceof HTMLStyleElement && styleElm.parentElement === document.head) {
      document.head.removeChild(styleElm);
      delete el[STYLE_ELM_STORE_KEY];
    }
  }

  Vue.directive('zm-select-dropdown-width-limit', {
    inserted(el, binding) {
      createOrUpdate(el, binding);
    },
    componentUpdated(el, binding, vnode, oldVnode) {
      if (oldVnode.elm && oldVnode.elm !== el) {
        unbind(oldVnode.elm, binding.oldValue);
      }
      createOrUpdate(el, binding);
    },
    unbind(el, binding) {
      unbind(el, binding.value);
    },
  });
}
